import { clsx } from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export function LoadingSpinner({ size = 'md', label }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div
        className={clsx(
          'animate-spin rounded-full border-b-2 border-brand-500',
          size === 'sm' && 'h-6 w-6',
          size === 'md' && 'h-10 w-10',
          size === 'lg' && 'h-14 w-14'
        )}
      />
      {label && <p className="mt-3 text-sm text-gray-500">{label}</p>}
    </div>
  );
}
